import { useAtomValue } from 'jotai';
import { shipRegionAtom } from '@/atoms';

export const useShipRegion = () => {
  const shipRegion = useAtomValue(shipRegionAtom);

  return shipRegion;
};
